import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.green.css'
import 'owl.carousel'

/*jQuery*/
class owlCarousel {
  clients() {
    $('.owl-carousel.--clients-rows-1').owlCarousel({
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: 3000,
      center: false,
      dots: true,
      nav: true,
      loop: true,
      margin: 20,
      responsive: {
        0: {
          items: 1,
          nav: false,
        },
        600: {
          items: 3,
          nav: false,
        },
        768: {
          items: 3,
          nav: true,
        },
        1024: {
          items: 5,
          nav: true,
        },
      }
    })

    $('.owl-carousel.--clients-rows-2').owlCarousel({
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: 3000,
      center: false,
      dots: true,
      nav: false,
      items: 1,
      loop: true,
      margin: 20,
    })
  }
}

export default owlCarousel
